import React from 'react';
import ExternalLink from 'Components/ExternalLink';
import useRootUrlWithSubdomain from 'utils/hooks/useRootUrlWithSubdomain';
import { URL } from 'constants/urlMaps';
import styled from 'styled-components';
import HelpIcon from 'Components/Icon/HelpIcon';
import Text from 'Components/Typography/Text';
import { FontSize } from 'theme';

const Link = styled(ExternalLink)`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  margin-right: 10px;
  height: 16px;
`;

const HelpButton: React.FC<{ withIcon?: boolean; className?: string }> = ({ withIcon, className }) => {
  const { mainRoute } = useRootUrlWithSubdomain();

  return (
    <Link href={`${mainRoute}${URL.how_it_works}`} newTab className={className}>
      {withIcon && (
        <IconWrapper>
          <HelpIcon />
        </IconWrapper>
      )}
      <Text size={FontSize.s}>Помощь</Text>
    </Link>
  );
};

export default HelpButton;
